<template>
  <div class="dis_fx" :style="type == 'footer' ? 'width: 100%' : 'width: 70%'">
    <!-- <div class="item" v-if="type != 'footer'"><router-link to="/" tag="a" class="dis_fx">
      <span>{{ $t('home.home') }}</span>
      <img src="~@/assets/icon.png" v-if="type != 'pc'" />
    </router-link></div>
    -->

    <el-menu
      :default-active="activeNav"
      @select="handleSelect"
      class="el-menu-vertical-demo"
      router
      mode="horizontal"
    >
      <el-menu-item :index="'/'" :route="{ path: '/' }">
        {{ $t("home.home") }}
      </el-menu-item>

      <el-menu-item :index="'/about'" :route="{ path: '/about' }">
        {{ $t("home.about") }}
      </el-menu-item>

      <el-menu-item :index="'/new'" :route="{ path: '/new' }">
        {{ $t("home.news") }}
      </el-menu-item>

      <!-- <el-submenu :index="'/product'">
        <template #title>
          {{ $t("home.product") }}
        </template>
    
        <el-menu-item :index="'/product'">
          {{ $t("home.product_sub") }}
        </el-menu-item>
      </el-submenu> -->
      <el-submenu
        class="submenu_nav"
        v-for="item in nav"
        :key="'sub-' + item.id"
        :index="'sub-' + item.id"
        v-show="item.childList && item.childList.length > 0"
      >
        <template #title>
          {{ item.name }}
        </template>

        <el-menu-item
          v-for="child in item.childList"
          :key="child.id"
          :index="'child-' + item.to + '?nodeId=' + child.id"
          :route="{ path: item.to + '?nodeId=' + child.id }"
        >
          {{ child.name }}
        </el-menu-item>
      </el-submenu>
      <el-menu-item :index="'/contact'" :route="{ path: '/contact' }">
        {{ $t("home.contact") }}
      </el-menu-item>
    </el-menu>

    <!-- <el-menu style="display: none;" default-active="/" class="el-menu-vertical-demo" router mode="horizontal">
      <el-menu-item
        v-for="item in nav"
        :key="item.id"
        :index="item.id.toString()"
        :route="{ path: item.to }"
        v-show="!item.childList"
      >
        {{ item.name }}
      </el-menu-item>

      <el-submenu
        v-for="item in nav"
        :key="'sub-' + item.id"
        :index="'sub-' + item.id"
        v-show="item.childList && item.childList.length > 0"
      >
        <template #title>
          {{ item.name }}
        </template>

        <el-menu-item
          v-for="child in item.childList"
          :key="child.id"
          :index="'child-' + child.id"
          :route="{ path: item.to }"
        >
          {{ child.name }}
        </el-menu-item>
      </el-submenu>
    </el-menu> -->

    <div
      style="display: none"
      class="item"
      v-for="(item, index) in nav"
      :key="index"
      @mouseenter="handleMouseEnter(item, index)"
      @mouseleave="handleMouseLeave(item, index)"
    >
      <router-link
        :to="item.to"
        tag="a"
        class="dis_fx"
        v-if="!item.child || type != 'mobile'"
      >
        <span>{{ item.name }}</span>
        <img src="~@/assets/icon.png" v-if="!item.show && type != 'pc'" />
        <img src="~@/assets/icon-.png" v-else-if="type != 'pc'" />
      </router-link>

      <!-- <div class="as dis_fx" v-else @click="handleClick(item,index)">
        <span>{{item.name}}</span>
        <img src="~@/assets/icon.png" v-if="!item.show && type != 'pc'"/>
        <img src="~@/assets/icon-.png" v-else-if="type != 'pc'"/>
      </div> -->
      <!-- <div class="child" v-if="item.childList && item.show">
        <div class="itm" v-for="(child,childindex) in item.childList" :key="childindex">
          <div :class="['as dis_fx',child.show?'open':'']" @click.stop="clickChild(child,childindex)">
            <span class="ellipsis">{{child.name}}</span>
            <img src="~@/assets/icon2.png" v-if="child.childList.length"/>
          </div>
          <div class="child2" v-if="child.childList && child.show" style="padding: 0 30px;">
            <div :class="['as dis_fx',childs.show?'open':'']" @click.stop="clickChild(childs,childindex)" v-for="(childs,childsindex) in child.childList" :key="childsindex">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <span class="ellipsis">{{childs.name}}</span>
                <img src="~@/assets/icon2.png" v-if="childs.childList.length"/>
              </div>

              <div class="child2" v-if="childs.childList && childs.show">
                <div class="as" @click.stop="clickChild(childs1,childindex)" v-for="(childs1,childsindex1) in childs.childList" :key="childsindex1">
                  <span class="ellipsis">{{childs1.name}}</span>

                  <div>

                    
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <div class="item"><a href="#" @click="scrollToSection('contact')" class="dis_fx">
      <span>{{ $t('home.contact') }}</span>
      <img src="~@/assets/icon.png" v-if="type != 'pc'" />
    </a></div> -->
    <div class="lang" @click="lang_change()" v-if="type != 'footer'">
      {{ langType ? "EN" : "CN" }}
    </div>
  </div>
</template>

<script>
import VueScrollTo from "vue-scrollto";
import { getTreeselect } from "@/api/product";
import { compileStr, uncompileStr } from "@/utils/tools";
export default {
  name: "Navigation",
  props: {
    type: {
      type: String,
      default: "pc",
    },
  },
  data() {
    return {
      langType:
        this.cookie.get("lang") == "" ||
        this.cookie.get("lang") == undefined ||
        this.cookie.get("lang") == "zh"
          ? true
          : false,
      nav: [],
      activeNav: this.$route.query.nodeId
        ? this.$route.path + "?nodeId=" + this.$route.query.nodeId
        : this.$route.path,
    };
  },
  watch: {
    $route(newRoute) {
      // this.updateActiveNav();
    },
  },
  created() {
    // let navStr = sessionStorage.getItem("nav");
    // let navList = navStr ? JSON.parse(uncompileStr(navStr) || '{}') : [];
    // if (!navList.length) {
    //   this.get_prod_tree_list();
    // } else {
    //   this.nav=
    //   [
    //     {name: this.$t('home.about'), to: '/about'},
    //     {name: this.$t('home.news'), to: '/new'},
    //     {name: this.$t('home.product'), to: '/product', show: false, childList:navList}
    //   ]
    // }
    this.get_prod_tree_list();
    // this.updateActiveNav();
  },
  methods: {
    updateActiveNav() {
      const path = this.$route.path;

      if (this.$route.query.nodeId) {
        this.activeNav = path + "?nodeId=" + this.$route.query.nodeId;
      } else {
        this.activeNav = path;
      }

      // this.nav.forEach((item) => {
      //   if (item.to === path) {
      //     console.log(item,'===item')
      //     if(this.$route.query.nodeId){
      //       console.log(item.to+ "?nodeId="+this.$route.query.nodeId,'=======')
      //       this.activeNav = item.to+ "?nodeId="+this.$route.query.nodeId;

      //     }else{
      //       this.activeNav = item.to;

      //     }
      //   }
      // });
    },
    handleSelect(url){
      if (url.includes("productList")) {
        sessionStorage.removeItem('navObj')
      }
    },
    lang_change() {
      this.langType = !this.langType;
      if (this.langType) {
        this.$i18n.locale = "zh";
        this.set_cookie("lang", "zh", 6); // 第一个参数是名字，第二个参数是当前的语言，第三个参数是表示 cookie 过期时间，可能是6（天）
      } else {
        this.$i18n.locale = "en";
        this.set_cookie("lang", "en", 6);
      }
      window.location.href = '/'
    },
    get_prod_tree_list() {
      getTreeselect().then((res) => {
        let oneList = res.data;
        oneList.forEach((item, index) => {
          item.to = "/productList";
          item.show = false;
          item.name = this.langType ? item.cnName : item.enName;
          item.child =
            item.childList && item.childList.length ? item.childList : [];
          item.child.forEach((it, ind) => {
            it.child = it.childList && it.childList.length ? it.childList : [];
            it.to = "/productList";
            it.name = this.langType ? it.cnName : it.enName;
            it.show = false;

            it.child.forEach((it3, ind3) => {
              it3.to = "/productList";
              it3.name = this.langType ? it3.cnName : it3.enName;
              it3.show = false;
            });
          });
        });

        let nav1 = [
          { name: this.$t("home.home"), to: "/", id: 0 },
          { name: this.$t("home.about"), to: "/about", id: 1 },
          { name: this.$t("home.news"), to: "/new", id: 2 },
          {
            name: this.$t("home.product"),
            to: "/productList",
            id: 3,
            show: false,
            childList: oneList,
          },
          // {name: this.$t('home.contact'), to: '/contact',id:4,},
        ];
        let nva2 = [
          { name: this.$t("home.about"), to: "/about", id: 1 },
          {
            name: this.$t("home.product"),
            to: "/productList",
            id: 3,
            show: false,
            childList: oneList,
          },
          // {name: this.$t('home.contact'), to: '/contact',id:4,},
        ];
        this.nav = !this.langType ? nva2 : nav1;

        // sessionStorage.setItem('nav', compileStr(JSON.stringify(oneList)));
      });
    },
    scrollToSection(sectionId) {
      VueScrollTo.scrollTo(`#${sectionId}`, 500);
      this.$emit("change");
    },
    handleMouseEnter(e, idx) {
      if (this.type != "pc") return;
      if (e.childList) {
        e.show = !e.show;
      }
    },
    handleMouseLeave(e) {
      if (this.type != "pc") return;
      if (e.childList) {
        e.show = !e.show;
      }
    },
    handleClick(e, idx) {
      if (e.childList) {
        e.show = !e.show;
      }
    },
    clickChild(e, idx) {
      // if(e.childList.length){
      e.show = !e.show;
      this.$router.push({
        path: "/productList?nodeId=" + e.id,
      });
      // }else {
      // this.$router.push({
      //   path: '/product#pro'+idx
      // })
      // this.scrollToSection('pro'+idx)
      // }
    },
    clickChild3(e) {
      e.show = !e.show;
      this.$router.push({
        path: "/productList?nodeId=" + e.id,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.el-menu-vertical-demo {
  margin-top: 27px;
  background: transparent;
}
.el-menu--horizontal > .el-menu-item {
  border: none;
  border-top: 4px solid transparent;
  display: inline-block;
  color: #fff;
  font-size: 1.8rem;
  text-align: center;
  padding: 0;
  margin: 0 20px;
}
.submenu_nav {
  padding: 0;
}
::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title {
  border: none;
  border-top: 4px solid transparent;
  display: inline-block;
  color: #fff;
  font-size: 1.8rem;
  text-align: center;
  padding: 0;
  margin: 0 20px;
}

::v-deep .el-submenu__title:hover {
  background: transparent !important;
  background-color: transparent !important;
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: transparent !important;
  background-color: transparent !important;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-top: 4px solid #443185;
  color: #443185;
  border-bottom: none;
}
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  background: #443185;
  color: #fff;
  padding: 0 10px;
}
menu--popup .el-menu-item:not(.is-disabled):focus,
.el-menu--popup .el-menu-item:not(.is-disabled):hover {
  color: #ea4fb1 !important;
}
.el-menu--horizontal .el-menu .el-menu-item.is-active,
.el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title {
  color: #ea4fb1 !important;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  padding: 0;
  margin: 0 20px;
}
::v-deep .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-top: 4px solid #443185;
  color: #443185;
  border-bottom: none;
}
.el-menu.el-menu--horizontal {
  border: none;
  display: flex;
}
.lang {
  margin-left: 100px;
  color: #fff;
  font-size: 16px;
  margin-top: 35px;
  cursor: pointer;
}
@media (max-width: 768px) {
  .lang {
    margin-top: 20px;
    margin-left: 20px;
    font-size: 14px;
    display: none;
  }
  .el-menu--horizontal>.el-menu-item{
    height: 40px;
    line-height: 40px;
  }
  .el-menu.el-menu--horizontal {
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: flex-start;
  }
  .el-menu--horizontal > .el-menu-item.is-active{
    border-color: #ea4fb1;
    color: #ea4fb1;
    border-top: none;
  }
  ::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title{
    color: #fff!important;
  }
  ::v-deep .el-menu-vertical-demo .el-submenu__title{
    color: #fff!important;

  }
  
  
}
</style>
